export default __webpack_public_path__ + "static/media/stroller_0.fd1fbf70.jpg";